var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAndroidMonochrome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 11.946v8.016c0 1.066-.82 1.917-1.862 1.917C1.002 21.88 0 21.021 0 19.962v-8.016c0-1.046 1.002-1.904 2.038-1.904 1.022 0 1.862.858 1.862 1.904Zm.731 10.868c0 1.135.894 2.049 2.004 2.049h1.348l.02 4.23c0 2.553 3.738 2.533 3.738 0v-4.23h2.518v4.23c0 2.54 3.758 2.546 3.758 0v-4.23h1.368c1.097 0 1.99-.914 1.99-2.05V10.396H4.631v12.419Zm16.792-13.09H4.557c0-2.963 1.733-5.538 4.306-6.881L7.57.399c-.19-.339.29-.553.453-.263l1.314 2.465c2.363-1.073 5.078-1.018 7.333 0L17.977.143c.169-.297.643-.076.453.263l-1.293 2.437c2.553 1.343 4.286 3.918 4.286 6.88ZM9.865 5.882a.719.719 0 0 0-.71-.727c-.387 0-.691.332-.691.727 0 .394.311.727.69.727.4 0 .711-.333.711-.727Zm7.678 0c0-.395-.311-.727-.69-.727-.4 0-.711.332-.711.727 0 .394.311.727.71.727.38 0 .691-.333.691-.727Zm6.419 4.16c-1.022 0-1.862.838-1.862 1.904v8.016c0 1.066.84 1.917 1.862 1.917 1.043 0 2.038-.858 2.038-1.917v-8.016c0-1.066-1.002-1.904-2.038-1.904Z",
    fill: "#F3F2F1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAndroidMonochrome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/android-monochrome.431e251ab9f2a46b56eea2681d212657.svg";